import { createContext, useContext } from 'react';
import { useOpenClose } from '@evertrue/et-components';
import PropTypes from 'prop-types';

const ContactModalContext = createContext(null);

const ContactModalProvider = ({ children }) => {
  const [contactModalIsOpen, openContactModal, closeContactModal] = useOpenClose(false);

  return (
    <ContactModalContext.Provider value={{ contactModalIsOpen, openContactModal, closeContactModal }}>
      {children}
    </ContactModalContext.Provider>
  );
};

ContactModalProvider.propTypes = {
  children: PropTypes.node,
};

export { ContactModalProvider, ContactModalContext };
export const useContactModalContext = () => useContext(ContactModalContext);
